import { ICellRendererParams } from "ag-grid-community";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";

import theme from "../../../../theme";

export const CompareInnerRenderer = (props: ICellRendererParams) => {
  const node = props.node;

  return (
    <IgTypography
      sx={{
        color: theme.palette.secondary.main,
        fontSize: "13px",
        fontWeight: 600,
      }}
    >
      {node.key}
    </IgTypography>
  );
};
